//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export bankrecledgerconfig
export const newReportsConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/bankRec/Reports",
      component: FuseLoadable({
        loader: () => import("./AdvanceReport.js")
      })
    }
  ]
  //end routes
};
